<!-- 
  列表页-列表设置
 -->

<template>
  <div class="setSort">
    <el-dialog
      :visible.sync="dialogVisible" 
      width="700"
      title="列表设置"
      :before-close="closeDialog">
      <div class="sort-box">
        <div class="sort-item" v-if="moduleName !== 'productStock'">
          <h3 class="title">默认排序规则</h3>
          <div class="sort-set">
            <span>默认按照</span>
            <el-select 
              v-model="sortOptin" 
              placeholder="请选择"
              @change="sortSet = 1">
              <el-option
                v-for="item in sortArray"
                :key="item.attr"
                :label="item.attrName"
                :value="item.attr">
              </el-option>
            </el-select>
            <el-select class="sort-select" v-model="sortSet" placeholder="请选择">
              <el-option label="升序" :value="1"></el-option>
              <el-option label="降序" :value="-1"></el-option>
            </el-select>
          </div>
        </div>
        <div class="sort-item">
          <h3 class="title">列表显示字段</h3>
          <div class="filter">
            <el-table
              ref="filterTable"
              :data="initValue"
              max-height="250"
              style="width: 100%"
              row-key="alias"
              >
              <el-table-column
                label="字段名称"
                width="120"
                prop="attrName">
              </el-table-column>
              <el-table-column
                label-class-name="label-class-name"
                type="selection"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { LS } from 'assets/js/storage'
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'

export default {
  props: {
    sortArray: {
      type: Array
    },
    initValue: {
      type: Array
    },
    templateId: {
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false,
      sortSet: 1,
      sortOptin: '',
      filterArray: []
    }
  },
  computed: {
    ...mapGetters([
      'moduleName'
    ]),
    // 过滤字段
    filterType () {
      return this.$route.path.replace(/\//g, '-')
    }
  },
  mounted () {
    this.dialogVisible = true
    if (this.moduleName !== 'productStock') {
      this.getSetSort()
    }
    this.$nextTick(() => {
      this.initFilterTable()
    })
  },
  methods: {
    getSetSort () {
      let url = `/listSortUserItem.html`
      let params = {
        refType: this.moduleName,
        templateId: this.templateId
      }
      if (this.moduleName === 'customerApi' && this.filterType.indexOf('isPublic') > -1) {
        params.child = 'isPublic'
      }
      api.post(url, params, (data) => {
        this.sortOptin = data.attr || ''
        this.sortSet = data.sortType || 1
      })
    },
    // 获取存储在本地的表头项
    initFilterTable () {
      if (this.$refs.filterTable) {
        let filteAttr = LS.get(`VUE-filter${this.templateId ? this.filterType + '-' + this.templateId : this.filterType}`) || []
        this.initValue.forEach((item) => {
          if (filteAttr.length > 0 && filteAttr.indexOf(item.attr) === -1) {
            this.$refs.filterTable.toggleRowSelection(item, true)
          } else if (!filteAttr.length) {
            this.$refs.filterTable.toggleRowSelection(item, true)
          }
        })
      } else {
        setTimeout(() => {
          this.initFilterTable()
        }, 1000)
      }
    },
    handleSubmit () {
      // 保存选中的表头
      let selection = this.$refs.filterTable.selection
      let filteAttr = []
      this.initValue.map(item => {
        if (selection.indexOf(item) === -1) {
          filteAttr.push(item.attr)
        }
      })
      if (this.moduleName === 'productStock' || !this.sortOptin) {
        LS.set(`VUE-filter${this.templateId ? this.filterType + '-' + this.templateId : this.filterType}`, filteAttr)
        this.closeDialog()
        Message({
          type: 'success',
          message: '设置成功!'
        })
        this.$emit('refresh')
        return
      }
      let url = `/listSortUserSave.html`
      let params = {
        refType: this.moduleName,
        attr: this.sortOptin,
        sortType: this.sortSet,
        templateId: this.templateId
      }
      if (this.moduleName === 'customerApi' && this.filterType.indexOf('isPublic') > -1) {
        params.child = 'isPublic'
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '设置成功!'
        })
        // 保存选中的表头
        LS.set(`VUE-filter${this.templateId ? this.filterType + '-' + this.templateId : this.filterType}`, filteAttr)
        this.closeDialog()
        this.$emit('refresh')
      })
    },
    // 关闭前执行
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style lang="less">
.setSort .filter {
  div.label-class-name {
    position: relative;
  }
  div.label-class-name:before {
    content: '是否显示';
    position: absolute;
    z-index: 100;
    background-color: #eef1f6;
    color: rgb(31, 45, 61);
    padding-left: 10px;
  }
}
</style>

<style lang="less" scoped>
.setSort {
  .sort-box {
    padding: 0 15px;
    .sort-item {
      .title {
        position: relative;
        font-size: 14px;
        color: #6781A1 100%;
      }
      .title::before {
        position: absolute;
        content: '';
        top: -4px;
        left: -16px;
        background: #6a82a4;
        width: 4px;
        height: 24px;
      }
      .sort-set {
        margin: 10px 20px;
        .el-select {
          margin-left: 15px
        }
        .sort-select {
          width: 100px;
        }
      }
      .filter {
        margin: 10px 20px;
        max-height: 300px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// set-sort.vue?e017248c